import { CheckCircleIcon, SmileyXEyesIcon, TimerIcon, XCircleIcon } from '@phosphor-icons/react';

export default function AttemptAnalysisLegend() {
  return (
    <div className="flex flex-row justify-between border-1 border-[var(--q3-stroke-normal)] border-dashed rounded-lg overflow-x-auto">
      <div className="flex flex-col min-w-[210px] gap-3 p-3 border-r border-dashed border-[var(--q3-stroke-normal)]">
        <div className="flex flex-row items-center gap-2 text-[var(--q3-green-normal)] text-sm font-medium">
          <CheckCircleIcon size={20} /> Perfect Attempt
        </div>
        <div className="text-[var(--q3-neutral-light)] text-sm">Correct attempt solved in time</div>
      </div>
      <div className="flex flex-col min-w-[210px] p-3 gap-3 border-r border-dashed border-[var(--q3-stroke-normal)]">
        <div className="flex flex-row items-center gap-2 text-[var(--q3-danger-normal)] text-sm font-medium">
          <XCircleIcon size={20} /> Wasted Attempt
        </div>
        <div className="text-[var(--q3-neutral-light)] text-sm">Incorrect attempt solved very quickly</div>
      </div>
      <div className="flex flex-col min-w-[210px] p-3 gap-3 border-r border-dashed border-[var(--q3-stroke-normal)]">
        <div className="flex flex-row items-center gap-2 text-[var(--q3-orange-normal)] text-sm font-medium">
          <TimerIcon size={20} /> Overtime Attempt
        </div>
        <div className="text-[var(--q3-neutral-light)] text-sm">Spent more than the allotted time</div>
      </div>
      <div className="flex flex-col min-w-[210px] p-3 gap-3">
        <div className="flex flex-row items-center gap-2 text-[var(--q3-neutral-light)] text-sm font-medium">
          <SmileyXEyesIcon size={20} /> Confused Attempt
        </div>
        <div className="text-[var(--q3-neutral-light)] text-sm">Unattempted & Spent more than the allotted time</div>
      </div>
    </div>
  );
}
